import { MailFrame } from '@/components/MailFrame';

/**
 * The signature, shown the way a vendor will receive it.
 *
 * The server appends the planner's signature to every outbound message — both
 * send paths, as a real HTML block with inline `cid:` images. That is the right
 * place for it (the client cannot build a multipart message), but it means the
 * composer's textarea no longer holds the whole email. This component closes
 * that gap: what the planner is about to send is the body they typed *plus*
 * this block, and they should be able to see both before they commit.
 *
 * Only for screens where the body is a live editor and cannot be folded into the
 * same document — the composer. A preview that owns the whole message renders
 * body and signature into one `MailFrame` instead, because that is what arrives.
 */

/**
 * Renders nothing at all when there is no signature. A planner who has not set
 * one up is not helped by an empty box explaining an absence — the composer
 * should simply look the way it did before the feature existed.
 */
export default function SignaturePreview({
  html,
  className,
}: {
  html: string | null | undefined;
  className?: string;
}) {
  const signature = html?.trim();
  if (!signature) return null;

  return (
    <div className={`space-y-1 ${className ?? ''}`}>
      <p className="label-caps text-xs text-muted-foreground">Your signature will be added</p>
      <MailFrame html={signature} title="Your signature" className="h-24" />
    </div>
  );
}
